// Lance la vidéo au clic sur la couverture (le parent ne fait que masquer la couverture)
document.querySelectorAll('.component_video-js').forEach(wrapper => {
    const cover = wrapper.querySelector('.video_cover');
    if (!cover) return;

    cover.addEventListener('click', () => {
        const video  = wrapper.querySelector('video');
        const iframe = wrapper.querySelector('iframe');

        if (video) {
            video.play();
        } else if (iframe) {
            const src = new URL(iframe.src);
            src.searchParams.set('autoplay', '1');
            iframe.src = src.toString();
        }

        wrapper.classList.add('is-playing');
    });
});
